module.exports = __webpack_public_path__ + "static/img/content.c76c166.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/content.png
// module id = xs36
// module chunks = 0